import { render, staticRenderFns } from "./miniprogramLink.vue?vue&type=template&id=081f8daf&scoped=true"
import script from "./miniprogramLink.vue?vue&type=script&lang=js"
export * from "./miniprogramLink.vue?vue&type=script&lang=js"
import style0 from "./miniprogramLink.vue?vue&type=style&index=0&id=081f8daf&prod&scoped=true&lang=css"
import style1 from "./miniprogramLink.vue?vue&type=style&index=1&id=081f8daf&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081f8daf",
  null
  
)

export default component.exports